<template>
    <div class="osc-table">
        <table class="table">
            <thead>
                <slot name="thead"></slot>
            </thead>

            <tbody>
                <slot name="tbody"></slot>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'Table',
};
</script>
<style lang="scss" scoped>
/* Styles are found in _table.scss */
</style>
